<template>
  <div class="policy-box">
    <h1 class="global_page_title">{{ title }}</h1>

    <div class="selectlist-box">
      <SelectList :selectlist="selectList" :selectvalue="selectKey" @click-item="onClickSelect" />
    </div>

    <div class="agreeinfo-box">
      <div class="left-tab">
        <CommonVerticalTab
          :selecttab="selectTab"
          :tablist="['이용약관', '개인정보 처리방침']"
          @click-tab="onClickTab"
        />
      </div>
      <div id="rightBox" class="rigt-box" v-html="serviceContent"></div>
    </div>
  </div>
</template>
<script>
import SelectList from '@/components/SelectList/SelectList.vue';
import CommonVerticalTab from '@/components/common/CommonVerticalTab.vue';
import { getStplatListApi } from '@/service/api/userApi';
export default {
  props: {
    tab: {
      type: Number,
      default: 1,
      required: false
    }
  },
  data() {
    return {
      stplatCate: 'TermsOfService',
      selectTab: 1,
      stplatList: [],
      serviceContent: '',
      serviceDate: null,
      selectKey: null,
      selectList: []
    };
  },
  components: {
    SelectList,
    CommonVerticalTab
  },
  created() {
    this.selectTab = this.tab;
    if (this.selectTab === 1) {
      this.getServiceList();
    } else {
      this.stplatCate = `PrivacyService`;
      this.getPrivacyList();
    }
  },
  methods: {
    getHtml(html) {
      const parser = new DOMParser();
      return parser.parseFromString(html, 'text/html').body.textContent;
    },
    onClickSelect(item) {
      this.selectKey = item.key;
      const find = this.stplatList.find(stplatItem => stplatItem.stplatSeq === item.key);
      if (find) {
        this.serviceContent = this.getHtml(find.stplatContents);
      }
    },
    onClickTab(val) {
      this.selectTab = val;
      if (this.selectTab === 1) {
        this.stplatCate = `TermsOfService`;
        this.getServiceList();
      } else if (this.selectTab === 2) {
        this.stplatCate = `PrivacyService`;
        this.getPrivacyList();
      }
    },
    async getServiceList() {
      try {
        const { data } = await getStplatListApi(this.stplatCate);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const parser = new DOMParser();
          this.selectKey = result[0].stplatSeq;
          this.serviceContent = parser.parseFromString(result[0].stplatContents, 'text/html').body.textContent;
          this.serviceDate = result[0].term;
          this.stplatList = result;
          this.selectList = result.map(item => {
            return {
              key: item.stplatSeq,
              value: item.term
            };
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getPrivacyList() {
      try {
        const { data } = await getStplatListApi(this.stplatCate);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const parser = new DOMParser();
          this.selectKey = result[0].stplatSeq;
          this.serviceContent = parser.parseFromString(result[0].stplatContents, 'text/html').body.textContent;
          this.serviceDate = result[0].term;
          this.stplatList = result;
          this.selectList = result.map(item => {
            return {
              key: item.stplatSeq,
              value: item.term
            };
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    title() {
      if (this.selectTab === 1) {
        return `이용약관`;
      } else {
        return `개인정보 처리방침`;
      }
    }
  },
  watch: {
    tab(val) {
      this.onClickTab(val);
    }
  },
  beforeDestroy() {
    if (this.type === 1) {
      this.$gatag.event('web_policy_show_back_button'); // 이용약관 뒤로가기
    }
  }
};
</script>
<style scoped src="@/assets/css/policybox/policybox.css"></style>
